var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timer__container", attrs: { id: "offer-timer" } },
    [
      _c("div", { staticClass: "timer__content" }, [
        _vm.timer
          ? _c("div", { staticClass: "timer__gift" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaBaseUrl + "subscription/gift.png",
                  alt: "gift"
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _c("div", { staticClass: "timeout-gift" }, [
              _c("div", { staticClass: "group" }, [
                _c("img", {
                  attrs: {
                    src: _vm.mediaBaseUrl + "subscription/gift.png",
                    alt: "gift"
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("Your gift")])
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("+")]),
              _vm._v(" "),
              _c("div", { staticClass: "group" }, [
                _c("img", {
                  attrs: {
                    src: _vm.mediaBaseUrl + "subscription/discount.png",
                    alt: "gift"
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("-82% off")])
              ])
            ]),
        _vm._v(" "),
        _vm.timer
          ? _c("div", { staticClass: "timer" }, [
              _c("div", { staticClass: "timer__block" }, [
                _c("span", { staticClass: "timer__number" }, [
                  _vm._v(_vm._s(_vm.formatTime(_vm.minutes)))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "timer__unit" }, [_vm._v("minutes")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "timer__block" }, [
                _c("span", { staticClass: "timer__number" }, [
                  _vm._v(_vm._s(_vm.formatTime(_vm.seconds)))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "timer__unit" }, [_vm._v("seconds")])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: "#plan2" } },
        [
          _c(
            "custom-button",
            { attrs: { animation: true, primary: true, light: true } },
            [_vm._v("\n      Get my gift\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gift__content" }, [
      _c("p", [_vm._v("We have a gift for you!")]),
      _vm._v(" "),
      _c("p", { staticClass: "pick-up" }, [
        _vm._v("Hurry up and pick up your gift")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }